import React, { useState, useEffect } from 'react';
import { Search, Menu, ChevronRight } from 'lucide-react';
import './Details.scss';
import BackLogo from '../../../../../../images/rewampimages/Chevron.png'
import { getDealerInfoForAgentById } from '../ActionCreator';
import Loader from '../../../../../presentationals/Loader/Loader.component'

import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import styled from "@emotion/styled";

const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: '#fff',
        color: '#222',
        boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
        borderRadius: '10px',
        padding: '10px 15px',
        fontSize: '13px',
        fontFamily: 'Arial, sans-serif',
        maxWidth: '250px',
    },
    [`& .${tooltipClasses.arrow}`]: {
        color: '#fff',
    },
}));


const HubDashboard = ({ InfoDataId, EditData, handlecurrentTab }) => {
    const [Data, setData] = useState({})
    const [loader, setLoader] = useState(false)

    useEffect(() => {
        console.log("Info", InfoDataId)
        getDealerInfoForAgentByIdFn()
    }, [])

    const getDealerInfoForAgentByIdFn = () => {
        setLoader(true)
        getDealerInfoForAgentById(InfoDataId, callback => {
            setLoader(false)
            setData(callback?.data || {})
        })
    }

        const renderDealerTooltip = (dealer) => (
        <div style={{ fontFamily: 'Arial, sans-serif', fontSize: '13px', minWidth: '200px' }}>
            <div style={{
                fontWeight: 'bold',
                marginBottom: '10px',
                color: '#1d3557',
                fontSize: '15px',
                borderBottom: '2px solid #ffa600',
                paddingBottom: '5px'
            }}>
                {dealer?.dealerName}
            </div>
            {dealer?.city || dealer?.state ? (
                <div style={{ marginBottom: '8px', color: '#666', fontSize: '12px' }}>
                    📍 {dealer?.city}{dealer?.city && dealer?.state ? ', ' : ''}{dealer?.state}
                </div>
            ) : null}
            {dealer?.emailId && (
                <div style={{ marginBottom: '5px', wordBreak: 'break-all' }}>
                    <strong>📧 Email:</strong> {dealer?.emailId}
                </div>
            )}
            {dealer?.mobileNumber && (
                <div style={{ marginBottom: '5px' }}>
                    <strong>📱 Mobile:</strong> {dealer?.mobileNumber}
                </div>
            )}

            <div style={{ marginTop: '8px', paddingTop: '8px', borderTop: '1px solid #eee', fontWeight: '600', color: '#064254' }}>
                📊 Total Leads: {dealer?.totalLeads || 0}
            </div>
            <div style={{ marginTop: '5px', fontWeight: '600', color: '#064254' }}>
                📊 Converted Leads: {dealer?.convertedLeads || 0}
            </div>
            <div style={{ marginTop: '5px', fontWeight: '600', color: '#064254' }}>
                📊 Auto Approved: {dealer?.approvedAuto || 0}
            </div>
            <div style={{ marginTop: '5px', fontWeight: '600', color: '#064254' }}>
                📊 Manual Approved: {dealer?.approvedManual || 0}
            </div>
            <div style={{ marginTop: '5px', fontWeight: '600', color: '#064254' }}>
                📊 Auto Rejected: {dealer?.rejectedAuto || 0}
            </div>
            <div style={{ marginTop: '5px', fontWeight: '600', color: '#064254' }}>
                📊 Manual Rejected: {dealer?.rejectedManual || 0}
            </div>
            <div style={{ marginTop: '5px', fontWeight: '600', color: '#064254' }}>
                📊 Additional Credit Review: {dealer?.additionalCreditReview || 0}
            </div>
            <div style={{ marginTop: '5px', fontWeight: '600', color: '#064254' }}>
                📊 Conversion Percentage: {dealer?.conversionPercentage || 0}%
            </div>
            
        </div>
    );

    return (
        <>
            {
                loader ? <Loader /> : ""
            }
            <div className="dashboard">
                <header className="dashboard-header">
                    <div className="header-left">
                        <div onClick={(e) => handlecurrentTab("main")} style={{ display: 'inline-flex', flexDirection: 'row', gap: '5px', alignItems: 'center' }}>
                            <div>
                                <img src={BackLogo} alt="" width={'70%'} style={{ marginRight: '10px', cursor: 'pointer', flexShrink: '0' }} />
                            </div>
                            <div >
                                <h1 className="dashboard-title"  > {EditData?.hubName}</h1>
                                <p className="hub-subtitle" style={{ marginBottom: '0' }}>{EditData?.address}</p>
                            </div>
                        </div>
                    </div>
                    <div className="header-right">
                        {/* <div className="search-box">
            <Search size={20} className="search-icon" />
            <input 
              type="text" 
              placeholder="Search hubs, agents..." 
              className="search-input"
            />
          </div>
          <button className="add-hub-button">
            + Add New Hub
          </button> */}
                    </div>
                </header>

                <main className="dashboard-content">
                    <div className="customcardbox">
                        <div className="manager-card">
                            <div className="manager-info">
                                <div className="avatar-circle blue">
                                    {Data?.name?.charAt(0)?.toUpperCase()}
                                </div>
                                <div className="manager-details">
                                    <p className="manager-label">AMU Agent</p>
                                    <h3 className="manager-name">{Data?.name}</h3>
                                    <div className="contact-info">
                                        <span className="contact-item">📧 {Data?.email}</span>
                                        <span className="contact-separator">•</span>
                                        <span className="contact-item">📱 {Data?.mobile}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="stats-grid">

                            <div className="stat-card">
                                <p className="stat-label">Total Dealers</p>
                                <p className="performance-value">{Data?.dealerCount ?? 0}</p>
                            </div>
                            <div className="stat-card">
                                <p className="stat-label">Total Leads</p>
                                <p className="performance-value">{Data?.performance?.totalLeads ?? 0}</p>
                            </div>
                            <div className="stat-card">
                                <p className="stat-label">Converted Leads</p>
                                <p className="performance-value">{Data?.performance?.convertedLeads ?? 0}</p>
                            </div>
                            <div className="stat-card">
                                <p className="performance-label">Avg Performance</p>
                                <p className="performance-value" style={{ color: "#10b981" }}>{Data?.performance?.conversionRate ?? 0}%</p>
                            </div>
                        </div>
                    </div>


                    <div className="agents-section">
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3 className="section-title">Dealers</h3>
                            {/* <h6 style={{margin:'0 0 24px 0',fontSize:'15px',cursor:'pointer',color:'#267dff'}} onClick={()=>handlecurrentTab("amuAgentList")}><i className='fa fa-eye' style={{color:'#267dff'}}></i> View</h6> */}
                        </div>
                        <div className="row ">
                            {Array.isArray(Data?.dealers) && Data?.dealers?.length > 0 ? Data?.dealers?.map((agent, id) => (
                                <div className='col-lg-4 col-sm-6 col-xs-12' key={id} style={{ marginTop: '25px' }}>
                                    <div className="agent-card nohoverclass">
                                        <div className="agent-info">
                                            <div className="avatar-circle green">
                                                {agent?.dealerName?.charAt(0)?.toUpperCase() || ""}
                                            </div>
                                            <div className="agent-details">
                                                <h4 className="agent-name" style={{fontSize:'15px'}}>{agent?.dealerName || ""}</h4>
                                                <div className="agent-stats" style={{ gap: '7px' }}>

                                                    {
                                                        agent?.mobileNumber ?
                                                            <span className="agent-stat">
                                                                📱 {agent?.mobileNumber || ""}
                                                            </span>
                                                            : ""}
                                                    {/* <span className="agent-stat">
                                                                🏢 {agent?.dealerCount || 0} Dealers
                                                            </span>
                                                            <span className="agent-stat">
                                                                👥 {agent?.performance?.totalLeads || 0} Total Leads
                                                            </span>
                                                            <span className="agent-stat">
                                                                👥 {agent?.performance?.convertedLeads || 0} Converted Leads
                                                            </span>
                                                            <span className={`agent-performance ${agent?.performance?.conversionRate >= 90 ? 'high' : agent?.performance?.conversionRate > 40 && agent?.performance?.conversionRate < 90 ? 'medium' : 'low'}`}>
                                                                📊 {agent?.performance?.conversionRate || 0}%
                                                            </span> */}
                                                </div>
                                            </div>
                                            <CustomTooltip
                                                    title={renderDealerTooltip(agent)}
                                                    arrow
                                                    placement="top"
                                                >
                                                    <InfoIcon style={{ marginLeft: '8px',fontSize:'14px', cursor: 'pointer', color: '#5d5c5c' }} />
                                                </CustomTooltip>
                                            {/* <div className='rightArrowShow'>
                                                            <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                                                        </div> */}
                                        </div>

                                    </div>
                                </div>
                            )) :
                                <div className='text-center' style={{ margin: '20px 0' }}>
                                    <p className="stat-label" style={{ marginBottom: '0' }}>No Dealer Found</p>
                                </div>
                            }
                        </div>
                    </div>

                </main>
            </div>
        </>
    );
};

export default HubDashboard;